import { requestApi } from 'api/Api';

import { formatDate, ia } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';
import {
  FORM_OPTIONS,
  PATIENT_OPTIONS,
  PROVIDER_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';
import FormsTippy from '../components/FormsTippy';

import { otherForms, statuses } from './constants';

const handleForms = (value) => {
  const forms = [];
  if (ia(value?.data?.forms)) {
    value?.data?.forms?.forEach((form) => {
      const matchedForm = otherForms.find(
        (otherForm) => otherForm?.id === form?.id || otherForm?.altId === form?.id
      );
      if (matchedForm) {
        forms.push(matchedForm?.name);
      }
    });
  }
  if (ia(value?.form_ids)) {
    value?.form_ids?.forEach((formId) => {
      forms.push(formId?.label);
    });
  }
  return forms;
};

const handleCompletedForms = (value) => {
  const completedArray = [];

  value?.data?.forms
    .filter((form) => form?.completed)
    .forEach((form) => {
      const matchedForm = otherForms.find(
        (otherForm) => otherForm?.id === form?.id || otherForm?.altId === form?.id
      );
      if (matchedForm) {
        completedArray.push(matchedForm?.name);
      }
    });
  value?.data?.forms
    .filter((form) => form?.completed)
    .forEach((form) => {
      const matchedForm = value?.form_ids.find((f) => f.value === form.id);
      if (matchedForm) {
        completedArray.push(matchedForm?.label);
      }
    });

  return completedArray;
};

const handleUnCompletedForms = (value) => {
  const unCompletedArray = [];

  value?.data?.forms
    .filter((form) => !form.completed)
    .forEach((form) => {
      const matchedForm = otherForms.find(
        (otherForm) => otherForm?.id === form?.id || otherForm?.altId === form?.id
      );
      if (matchedForm) {
        unCompletedArray.push(matchedForm?.name);
      }
    });
  value?.data?.forms
    .filter((form) => !form?.completed)
    .forEach((form) => {
      const matchedForm = value?.form_ids.find((f) => f.value === form.id);
      if (matchedForm) {
        unCompletedArray.push(matchedForm?.label);
      }
    });

  return unCompletedArray;
};

const getCountOfForms = (value) => {
  if (!value?.data?.forms || !ia(value.data.forms)) {
    return '-';
  }
  let completedCount = 0;

  value?.data?.forms.forEach((form) => {
    if (form.completed) {
      completedCount++;
    }
  });
  return `${completedCount}/${value?.data?.forms?.length}`;
};

export const defaultColumns = (timezone) => [
  {
    field: 'creator',
    headerName: 'Provider',
    cellClass: 'no-border',
    valueFormatter: ({ value }) =>
      ia(value) ? value.map((v) => `${v?.f_name} ${v?.l_name}`) : '-',
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'target',
    headerName: 'Patient',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (ia(value) ? value.map((v) => `${v?.f_name} ${v?.l_name}`) : '-')
  },
  {
    field: 'appointment.starts_at',
    headerName: 'Date of Service',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-')
  },
  {
    field: 'forms',
    headerName: 'Forms',
    cellClass: 'no-border',
    sortable: false,
    cellRenderer: (params) => <FormsTippy data={params?.data} formCallBack={handleForms} />
  },
  {
    field: 'no-completed-forms',
    headerName: 'No. of Completed Forms',
    cellClass: 'no-border',
    sortable: false,
    valueFormatter: (params) => getCountOfForms(params?.data)
  },
  {
    field: 'completed-forms',
    headerName: 'Completed Forms',
    cellClass: 'no-border',
    sortable: false,
    cellRenderer: (params) => <FormsTippy data={params?.data} formCallBack={handleCompletedForms} />
  },
  {
    field: 'incomplete-forms',
    headerName: 'Incomplete Forms',
    cellClass: 'no-border',
    sortable: false,
    cellRenderer: (params) => (
      <FormsTippy data={params?.data} formCallBack={handleUnCompletedForms} />
    )
  },
  {
    field: 'created_at',
    headerName: 'Created On',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-')
  },
  {
    field: 'expires_at',
    headerName: 'Link Expires On',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-')
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Created At',
    icon: 'calendar-mono'
  },
  provider: PROVIDER_OPTIONS,
  patient: PATIENT_OPTIONS,
  form: { ...FORM_OPTIONS, allowed_operators: ['is any of', 'is', 'is not'] },
  status: {
    title: 'Status',
    placeholder: 'Search by status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: statuses.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'form_packet_statuses.options',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is']
  }
};

export const sendLink = async ({ type = '', navigate, packets = [], setSelectedRows }) => {
  const params = {
    packets: packets.map((packet) => ({
      link: `${process.env.REACT_APP_BASE_URL}/ia/${packet?.data?.token}`,
      patientId: packet?.data?.target_id
    })),
    type
  };

  await requestApi({
    navigate,
    url: `/api/form/instant_packet/resend_multiple`,
    params
  });

  setSelectedRows([]);
  showAlert({ title: `Successfully sent ${type}` });
};
